import { Map } from 'immutable';
import { forEach } from 'lodash';
const is = {
  browserScope: {},
  sessionScope: {},
  endpoints: {},
};

// TODO - is there a way to loop through all of localStorage?  or maybe set
// a single localStorage object and loop through that instead.
// Don't make advertiserGroupId sticky because that makes the wrong
// advertisers show up if you switch users (as an admin).
forEach(['advertiserGroupId', 'advertiserId', 'advertiserName', 'features'], v => {
// _.forEach(['advertiserId'], v => {
  // console.log(`checking ${v}`);
  // console.log(`window.localStorage.getItem(v): ${window.localStorage.getItem(v)}`);
  try {
    is.browserScope[v] = v === 'features' ?
      window.localStorage.getItem(v) === null ? {} : JSON.parse(window.localStorage.getItem(v)) :
        window.localStorage.getItem(v) !== null ? v === 'advertiserName' ? window.localStorage.getItem(v) : Number(window.localStorage.getItem(v)) : null;
  } catch (e) {
    console.error('e: ');
    console.error(e);
    is.browserScope[v] = window.localStorage.getItem(v);
  }
});



const initialState = new Map(is);

export default initialState;

